// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".slider[data-v-3c906266]{background-color:#E2E2E2;width:100%;height:110px}.slider__outer[data-v-3c906266]{width:100%;height:100%;overflow-x:auto;overflow-y:hidden}.slider__inner[data-v-3c906266]{height:100%}\n", ""]);
// Exports
module.exports = exports;
